import { render, staticRenderFns } from "./GefilteShip.vue?vue&type=template&id=55100408&scoped=true&"
import script from "./GefilteShip.vue?vue&type=script&lang=js&"
export * from "./GefilteShip.vue?vue&type=script&lang=js&"
import style0 from "./GefilteShip.vue?vue&type=style&index=0&id=55100408&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55100408",
  null
  
)

export default component.exports